import PropTypes from "prop-types";

function TransactionRowCard({
  transaction,
  showBorder = true,
  getTransactionIconSrc,
}) {
  if (!transaction) return null;

  // Check if we actually have account info to display
  const hasAccount = Boolean(transaction.account);
  const hasLast4 = Boolean(transaction.last4);
  const showAccountRow = hasAccount || hasLast4;

  return (
    <div
      className="transaction-row-card-container"
      style={{
        borderBottom: showBorder ? "1px solid #F3F4F6" : "none",
      }}
    >
      {/* Left Side: Info */}
      <div className="trc-info">
        <div className="trc-merchant-row">
          {getTransactionIconSrc && (
            <img
              src={getTransactionIconSrc(transaction)}
              alt={transaction.merchant || "Merchant"}
              className="trc-icon"
            />
          )}
          <span className="trc-merchant">{transaction.merchant}</span>
        </div>

        {/* Only render account details if at least one exists */}
        {showAccountRow && (
          <div className="trc-account-row">
            <span className="trc-account">
              {hasAccount && transaction.account}
              {hasAccount && hasLast4 && " •••• "}
              {!hasAccount && hasLast4 && "•••• "}
              {hasLast4 && transaction.last4}
            </span>
          </div>
        )}
      </div>

      {/* Right Side: Date + Amount Stack */}
      <div className="trc-meta">
        <span className="trc-date">{transaction.date}</span>
        <span className="trc-amount">
          $
          {Number(transaction.amount || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}
        </span>
      </div>
    </div>
  );
}

TransactionRowCard.propTypes = {
  transaction: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    merchant: PropTypes.string,
    account: PropTypes.string,
    last4: PropTypes.string,
    date: PropTypes.string,
    amount: PropTypes.number,
  }).isRequired,
  showBorder: PropTypes.bool,
  getTransactionIconSrc: PropTypes.func,
};

export default TransactionRowCard;
